import { isPlatform } from '@ionic/angular';
import config from '../../capacitor.config';

export const domain = 'dev-5m2t594i.us.auth0.com';
export const clientId = 'ua2gyMqX8e4lBEixFw4RkH2MzUAqONFb';
const { appId } = config;

// Use `auth0Domain` in string interpolation below so that it doesn't
// get replaced by the quickstart auto-packager
const auth0Domain = domain;
const iosOrAndroid = isPlatform('hybrid');

export const callbackUri = iosOrAndroid
  ? `${appId}://${auth0Domain}/capacitor/${appId}/callback`
  : 'https://fauna.dev.hs1.com.br';
